import { LuArrowRight } from "react-icons/lu";

export const PolicyList = ({ policies, handlePolicy }) => {
  const Policy = ({ policyData }) => (
    <div
      className="policyItem"
      role="button"
      tabIndex={0}
      onClick={() => handlePolicy(policyData)}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          handlePolicy(policyData);
        }
      }}
    >
      <div>{policyData.icon}</div>
      <div>{policyData.title}</div>
      <div>
        <LuArrowRight />
      </div>
    </div>
  );

  return (
    <>
      {policies?.map((policy) => (
        <Policy policyData={policy} key={policy.id} />
      ))}
    </>
  );
};
